/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: enbo.zhou@dsicm.com
 * @Date: 2021-03-31 16:48:44
 * @LastEditors: enbo.zhou@dsicm.com
 * @LastEditTime: 2021-04-28 10:04:45
 * @FilePath: /dsicm-admin-web/src/views/questionnaire/api/index.js
 */

import req from '@/utils/req.js'
//新增问卷
export function addExam(params) {
  return req.post(`/dsicm-data-base/feign/exam-paper/addExam`, params)
}

//展示问卷
export function selectListExam(params) {
    return req.get(`/dsicm-data-base/feign/exam-paper/selectListExam`, params)
}
  
  //问卷列表查询
export function list(params) {
    return req.post(`/dsicm-data-base/feign/exam-paper/pageList`, params)
  }

//发布问卷
export function passQuestion(params) {
  return req.get(`/dsicm-data-base/feign/exam-paper/passQuestion`, params)
}

//发布问卷
export function updateExam(params) {
  return req.post(`/dsicm-data-base/feign/exam-paper/updateExam`, params)
}
//病人列表分页条件查询
export function searchPatient(params) {
  return req.post(`/admin/patient/page`,params)
}

//推送IM消息
export function pushIm(params) {
  return req.post(`/admin/exam-paper/pushIm`,params)
}